module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!./Group.js"));
	}, "Group");
}